import {Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BHQrCodeScannerModel } from '../bh-qrcode-scanner.model';

@Component({
    selector: 'abw-bh-qrcode-scanner-result',
    templateUrl: './bh-qrcode-scanner-result.component.html',
    styleUrls: ['./bh-qrcode-scanner-result.component.scss']
})
export class BHQrCodeScannerResultComponent implements OnInit {
	@Input() model: BHQrCodeScannerModel;
    @Input() value: any;

    constructor(
    ) {
    }

    ngOnInit() {
    }
}